let PricesDataForm = [
  {
    inputName: "Nombre",
    type: "Text",
    id: "id_301",
  },
  {
    inputName: "Ancho",
    type: "SmartMeasure",
    subtype: "length",
    id: "id_302",
  },
  {
    inputName: "Alto",
    type: "SmartMeasure",
    subtype: "length",
    id: "id_303",
  },
];

export default PricesDataForm;
